(function() {
    "use strict";

    /**
     * google tagmanager on mounted element
     *
     */
    ZZ.GtmTouchpointMounted = function(GtmTouchpointMountedContainer) {
        var base = this;

        if (typeof jQuery != "undefined") {
            base.container = GtmTouchpointMountedContainer.get(0);
        } else {
            base.container = GtmTouchpointMountedContainer;
        }

        base.datalayerData = JSON.parse(
            base.container.getAttribute("data-gtm-mounted-datalayer")
        );
        base.containerVisible = base.container.getAttribute(
            "data-gtm-mounted-visible"
        );

        base.init();
    };

    ZZ.GtmTouchpointMounted.prototype = {
        init: function() {
            var base = this;

            if (
                base.containerVisible === "true" &&
                base.container.offsetHeight !== 0
            ) {
                base.pushData();
            }
        },

        pushData: function(e) {
            var base = this;
            if (window["dataLayer"]) {
                window["dataLayer"].push(base.datalayerData);
            }
        }
    };
})();
